import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { formatYearToDate, parseDateToYear } from 'src/components/utils/dateFormatter';
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, M_ElementDrawer, NavigateContext} from 'src/M_Components'
import { Anchor, AttachMoney, Group, LabelOutlined, Refresh } from '@mui/icons-material'


export const EquipmentAndMovementCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editingId, setEditingId] = useState(null) 
    const [showEquipmentType, setShowEquipmentType] = useState(false)
    const [newEquipmentTypeData, setNewEquipmentTypeData] = useState({})

    //check digit validation
    const [showCheckDigitWarning, setShowCheckDigitWarning] = useState(false)
    

    const accountService = new BufferService('Account')

    const equipmentService = new BufferService('Equipment', 'secondary')
    const equipmentTypeService = new BufferService('EquipmentType', 'secondary')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage']

    const matches = useMediaQuery('(min-width:1800px)')
    const matches2 = useMediaQuery('(min-width:1700px)')
    const matches3 = useMediaQuery('(min-width:1490px)')
    const matches4 = useMediaQuery('(min-width:1450px)')
    const matches5 = useMediaQuery('(min-width:1420px)')
    const matches6 = useMediaQuery('(min-width:1380px)')
    const matches7 = useMediaQuery('(min-width:1280px)')
    const matches8 = useMediaQuery('(min-width:1230px)')
    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches10 = useMediaQuery('(min-width:1150px)')
    const matches11 = useMediaQuery('(min-width:970px)')
    const matches12 = useMediaQuery('(min-width:930px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches14 = useMediaQuery('(min-width:870px)')
    const matches15 = useMediaQuery('(min-width:615px)')
    const matches16 = useMediaQuery('(min-width:440px)')

    // ============================================================================
    // ==================== EQUIPMENT TYPE CREATION ===============================
    const addEquipmentTypeFields = [
        { display: t('Eq. Type ID'), required: true, type: 'text', code: 'equipmentTypeId' },
        { display: `${t('EquipmentType')} ${t('Name')}`, required: true, type: 'text', code: 'equipmentTypeName'},

        { display: t('Length'), required: true, type: 'number', code: 'length' },
        { display: t('Height'), type: 'decimal', code: 'height' },
        { display: t('Tare'), type: 'decimal', code: 'tare' },

        { display: `${t('EquipmentType')} ${t('Comments')}`, code: 'eqTypeComments', type: 'textArea', fullWidth: true, },
    ]

    const addEquipmentClassFields = [
        { display: t('Class Code'), required: true, code: 'classCode', fullWidth: true, type: 'foreignKey', entity: 'EquipmentClass', api:'secondary' , filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Name', value: 'className' }, { key: 'Code', value: 'classCode' }, { key: 'Id', value: 'classCodeId' }], },
        { display: t('Class Name'), code: 'className', type: 'disabled'},
    ]

    const saveNewEquipmentType = () => {
        // Validations
        if (!newEquipmentTypeData.equipmentTypeId || !newEquipmentTypeData.equipmentTypeName || !newEquipmentTypeData.length || !newEquipmentTypeData.classCodeId) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }
        
        ctx.setIsLoad(true)
        
        const equipmentTypeData = {
            Code: newEquipmentTypeData.equipmentTypeId,
            Name: newEquipmentTypeData.equipmentTypeName,
            Length: parseFloat(newEquipmentTypeData.length),
            Height: newEquipmentTypeData.height ? parseFloat(newEquipmentTypeData.height) : 0,
            TareWeight: newEquipmentTypeData.tare ? parseFloat(newEquipmentTypeData.tare) : 0,
            Comments: newEquipmentTypeData.eqTypeComments || '',

            EquipmentClassId: newEquipmentTypeData.classCodeId,
        }

        equipmentTypeService.post(equipmentTypeData).then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', `${t('Failed to create')} ${t('EquipmentType')}`)
                return
            }
            
            changes('equipmentTypeId', response.Id?.toString(), setData)
            changes('equipmentTypeName', response.Name, setData)
            changes('classCode', response.Code, setData)
            changes('length', response.Length?.toString(), setData)
            changes('equipmentTypeTare', response.TareWeight?.toString(), setData)
            
            ctx.toastMessages('success', '', `${t('EquipmentType')} ${t('savedSuccessfully')}`)
            setShowEquipmentType(false)
            setNewEquipmentTypeData({})
            
        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error creating Equipment Type:', error)
            ctx.toastMessages('error', '', `${t('Failed to create')} ${t('EquipmentType')}`)
        })
    }
    // ============================================================================

    // Fields
    const EquipmentAndMovementFields = [
            { display: t('Prefix'), required: true, code: 'prefix', type: isEditMode ? 'disabled' : 'text' },
            { display: t('Number'), required: true, code: 'number', type: isEditMode ? 'disabled' : 'number' },
            { display: t('CD'), required: true, code: 'cd', type: isEditMode ? 'disabled' : 'number' },

        
        { display: t('Inside') + ' ' + t('Height'), code: 'insideHeight', type: 'decimal' },
        { display: t('GrossWeight'), code: 'grossWeight', type: 'decimal' },
        { display: t('Payload'), code: 'payload', type: 'decimal' },
        { display: t('Tare'), code: 'tare', type: 'decimal' },
        { display: t('Inside') + ' ' + t('Length'), code: 'insideLength', type: 'decimal' },
        { display: t('Inside') + ' ' + t('Width'), code: 'insideWidth', type: 'decimal' },
        { display: t('Inside') + ' ' + t('Cubic'), required: true, code: 'insideCubic', type: 'decimal' },
        { display: t('Year Built'), code: 'yearBuilt', type: 'number' },

        { type: 'separator' }, { display: t('Equipment') + ' ' + t('Comments'), code: 'description', type: 'textArea', fullWidth: true }
    ]
    const EquipmentTypeFields = [
        { type: 'separator' },{ display: t('Eq. Type ID'), required: true, code: 'equipmentTypeId', fullWidth: true, type: 'foreignKey', entity: 'EquipmentType', api:'secondary' , filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Name', value: 'equipmentTypeName' }, { key: 'Code', value: 'classCode' },{key: 'Length', value: 'length'}, {key:'TareWeight', value: 'equipmentTypeTare'}, { key: 'Id', value: 'equipmentTypeId' }], },
        
        { display: t('EquipmentType'), code: 'equipmentTypeName', type: 'disabled' },
        { display: t('Length'), code: 'length', type: 'disabled' },
        { display: t('Class Code'), code: 'classCode', type: 'disabled' },
        { display: t('EquipmentType') + ' ' + t('Tare'), code: 'equipmentTypeTare', type: 'disabled' }
    ]
    const EquipmentLineFields = [
        { display: t('Equipment') + ' ' + t('Line Code'), code: 'equipmentLineCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'equipmentLineCode' }, { key: 'AccountName', value: 'equipmentLineName' }, { key: 'Id', value: 'equipmentLineId' }], },
        { display: t('Equipment') + ' ' + t('Line') + ' ' + t('Name'), code: 'equipmentLineName', type: 'disabled' }
    ]
    const EquipmentOwnerFields = [
        { display: t('Equipment') + ' ' + t('Owner Code'), code: 'equipmentOwnerCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'equipmentOwnerCode' }, { key: 'AccountName', value: 'equipmentOwnerName' }, { key: 'Id', value: 'equipmentOwnerId' }], },
        { display: t('Equipment') + ' ' + t('Owner Name'), code: 'equipmentOwnerName', type: 'disabled' },

        { display: t('SOC'), type: 'checkBox', code: 'soc' }
    ]


    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingEquipment = JSON.parse(sessionStorage.getItem('editingEquipment'))
            const operationType = sessionStorage.getItem('operationType')
            
            if (editingEquipment && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyEquipment(editingEquipment.Id, operationType === 'Copy')
                
                sessionStorage.removeItem('editingEquipment')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
                sessionStorage.removeItem('operationType')
            }
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, leavingPage])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {

            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            ctx.setIsLoad(false)

            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)
    }

    const checkEquipmentExists = async (prefix, number, checkDigit, excludeId = null) => {
        if (!prefix || !number || !checkDigit) return false
        
        try {
            const response = await equipmentService.filter(`?filter=Prefix eq '${prefix}'`)
            
            if (response.name === 'AxiosError' || !response.Items) {
                return false
            }
            
            const exactMatch = response.Items.find(item => 
                item.Prefix === prefix && 
                item.Number === parseInt(number) && 
                item.CheckDigit === parseInt(checkDigit) &&
                item.Id !== excludeId 
            )
            
            return !!exactMatch

        } catch (error) {
            console.error('Error checking equipment:', error)
            return false
        }
    }

    const refreshEquipment = () => {
        ctx.setIsLoad(true)
        
        sessionKeys.forEach(key => {
            sessionStorage.removeItem(`${id}${key}`)
        })
        
        // Initial values
        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null) 
        
        get()
        
        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')    
    }

    const onSave = async (forceCreation = false) => {
        // Validations
        if (!data.prefix || data.prefix.length !== 4) {
            ctx.toastMessages('error', '', t('Prefix must be exactly 4 letters'))
            return
        }

        if (!data.number || data.number.length < 6 || data.number.length > 6) {
            ctx.toastMessages('error', '', t('Number must be exactly 6 digits'))
            return
        }

        if (!data.cd || data.cd.length < 1 || data.cd.length > 1) {
            ctx.toastMessages('error', '', t('Check Digit must be exactly 1 digit'))
            return
        }
        if (!data.number || !data.cd || !data.insideCubic || !data.equipmentTypeId) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }

        const prefixChanged = data.prefix?.toUpperCase() !== data._originalPrefix
        const numberChanged = data.number?.toString() !== data._originalNumber
        const cdChanged = data.cd?.toString() !== data._originalCd

        if (!isEditMode || (isEditMode && (prefixChanged || numberChanged || cdChanged))) {
            ctx.setIsLoad(true)
            const exists = await checkEquipmentExists(
                data.prefix.toUpperCase(),
                parseInt(data.number),
                parseInt(data.cd),
                editingId
            )
            ctx.setIsLoad(false)

            if (exists) {
                ctx.toastMessages('error', '', t('Equipment') + ` ${data.prefix.toUpperCase()} ${data.number} ${data.cd} ${t('alreadyExists')}`)
                return
            }
        }

        const equipmentData = {
            Prefix: data.prefix.toUpperCase(),
            Number: parseInt(data.number),
            CheckDigit: parseInt(data.cd),
            GrossWeight: parseFloat(data.grossWeight),
            InsideCubic: parseFloat(data.insideCubic),
            InsideHeight: parseFloat(data.insideHeight),
            InsideLength: parseFloat(data.insideLength),
            InsideWidth: parseFloat(data.insideWidth),
            TareWeight: parseFloat(data.tare) || parseFloat(data.equipmentTypeTare) || 0,
            YearOfManufacture: data.yearBuilt ? formatYearToDate(data.yearBuilt) : new Date(1900, 0, 1).toISOString(),
            Payload: parseFloat(data.payload) || 0,
            Comment: data.description || '',
            LineId: data.equipmentLineId,
            OwnerId: data.equipmentOwnerId,
            SOC: data.soc || false,
            EquipmentTypeId: parseInt(data.equipmentTypeId) || 1,
            ForceCreation: forceCreation  
        }

        ctx.setIsLoad(true)

        const savePromise = isEditMode && editingId
            ? equipmentService.update(editingId, equipmentData)
            : equipmentService.post(equipmentData)

        savePromise.then(response => {
            ctx.setIsLoad(false)

            if (response.name === 'AxiosError') {
                // Check if it's specifically the InvalidCheckDigit warning
                if (response.response?.data?.ruleName === 'InvalidCheckDigit') {
                    setShowCheckDigitWarning(true)
                    return
                }
                handleError(response)
                return
            }

            const successMessage = isEditMode
                ? t('Equipment') + ' ' + t('updatedSSuccessfully')
                : t('Equipment') + ' ' + t('savedSuccessfully')
            ctx.toastMessages('success', '', successMessage)
            ctx2.closeTab(JSON.parse(id))

        }).catch(error => {
            ctx.setIsLoad(false)
            handleError(error)
        })
    }

    const onForceCreation = () => {
        setShowCheckDigitWarning(false)
        onSave(true)
    }

    const editOrCopyEquipment = (equipmentId, isCopy = false) => {
        ctx.setIsLoad(true)
        
        equipmentService.getId(equipmentId).then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', t('Failed to load') + ' ' + t('Equipment'))
                return
            }
            
            // Mapper
            const equipmentData = {
                prefix: isCopy ? '' : (response.Prefix || ''),
                number: isCopy ? '' : (response.Number?.toString() || ''),
                cd: isCopy ? '' : (response.CheckDigit?.toString() || ''),

                _originalPrefix: response.Prefix || '',
                _originalNumber: response.Number?.toString() || '',
                _originalCd: response.CheckDigit?.toString() || '',

                grossWeight: response.GrossWeight?.toString() || '',
                insideCubic: response.InsideCubic?.toString() || '',
                insideHeight: response.InsideHeight?.toString() || '',
                insideLength: response.InsideLength?.toString() || '',
                insideWidth: response.InsideWidth?.toString() || '',
                tare: response.TareWeight?.toString() || '',
                payload: response.Payload?.toString() || '',
                description: response.Comment || '',
                soc: response.SOC || false,
                yearBuilt: parseDateToYear(response.YearOfManufacture),
                
                // Equipment type
                equipmentTypeId: response.EquipmentTypeId?.toString() || '',
                
                // Line and Owner
                equipmentLineId: response.LineId || '',
                equipmentOwnerId: response.OwnerId || '',

                _isCopy: isCopy,
                _originalId: isCopy ? equipmentId : null
            }

            if (isCopy) {
                delete equipmentData.Id
                delete equipmentData.ExternalId
                delete equipmentData.CreatedAt
                delete equipmentData.UpdatedAt

                setIsEditMode(false)  
                setEditingId(null)        
                setOperation('Create')    
            } else {
                setIsEditMode(true)         
                setEditingId(equipmentId) 
                setOperation('Edit')      
            }

            setData(equipmentData)
                
            if (response.EquipmentTypeId) {
                const equipmentTypeService = new BufferService('EquipmentType', 'secondary')
                equipmentTypeService.getId(response.EquipmentTypeId).then(eqType => {
                    if (eqType.name !== 'AxiosError') {
                        changes('equipmentTypeName', eqType.Name, setData)
                        changes('classCode', eqType.Code, setData)
                        changes('length', eqType.Length?.toString(), setData)
                        changes('equipmentTypeTare', eqType.TareWeight?.toString(), setData)
                    }
                })
            }
            
            if (response.LineId) {
                accountService.getId(response.LineId).then(lineAccount => {
                    if (lineAccount.name !== 'AxiosError') {
                        changes('equipmentLineCode', lineAccount.AccountCode, setData)
                        changes('equipmentLineName', lineAccount.AccountName, setData)
                    }
                })
            }
            
            if (response.OwnerId) {
                accountService.getId(response.OwnerId).then(ownerAccount => {
                    if (ownerAccount.name !== 'AxiosError') {
                        changes('equipmentOwnerCode', ownerAccount.AccountCode, setData)
                        changes('equipmentOwnerName', ownerAccount.AccountName, setData)
                    }
                })
            }
        
        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error loading equipment:', error)
            ctx.toastMessages('error', '', t('Failed to load') + ' ' + t('Equipment'))
        })
    }
    
    const handleError = (error) => {
        
        let errorMessage = t('Error saving') + ' ' + t('Equipment')
            if (Array.isArray(data)) {
            errorMessage = data.map(e => `${e.field}: ${e.message}`).join('\n')
        } else if (data?.errors) {
            errorMessage = Object.entries(data.errors)
                .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                .join('; ')
        } else if (data?.message) {
            errorMessage = data.field ? `${data.field}: ${data.message}` : data.message
        } else if (data?.detail) {
            errorMessage = data.detail
        } else if (data?.title) {
            errorMessage = data.title
        } else if (error.message) {
            errorMessage = error.message
        }

        ctx.toastMessages('error', '', errorMessage)
    }


    return (
        <div >
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshEquipment()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save "></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><i className="pi pi-box" style={{ marginRight: '10px', scale: '1.3' }} /> {t("Equipment") + ' ' + t("Details")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches13 && 'auto auto' || !matches6 && 'auto auto auto' || 'auto auto auto auto auto', justifyContent: 'space-evenly' }}>
                                {EquipmentAndMovementFields.map((field, index) => {
                                    if (field.type === 'separator') {
                                        //New line
                                        return <div key={`separator-${index}`} style={{ gridColumn: '1 / -1', height: '0' }} />;
                                    }
                
                                    if (field.fullWidth) {
                                        return (
                                            <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                                {fields(field, index, data, setData, false, null, '100%')}
                                            </div>
                                        );
                                    }
                                    return fields(field, index, data, setData, null, null)
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: !matches16 && 'auto ' || !matches10 && 'auto' || 'auto auto auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><Anchor  style={{ marginRight: '10px', scale: '1.3' }} /> {t("EquipmentType")}</div>}
                        headerElement={
                            <M_Button
                                bold
                                normal
                                hoverEffect
                                tooltip={t('Add') + ' ' + t('New') + ' ' + t('EquipmentType')}
                                label={matches15 ? t("Add") + " " + t("EquipmentType") : ""}
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                                icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t("Add")} style={{ filter: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7477%) hue-rotate(324deg) brightness(94%) contrast(109%)' }} className='iconCreateBooking' />}
                                onClick={() => setShowEquipmentType(true)}
                            />
                        }
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches13 && 'auto auto' || 'auto auto', justifyContent: 'space-evenly' }}>
                                {EquipmentTypeFields.map((field, index) => {
                                    if (field.type === 'separator') {
                                        return <div key={`separator-${index}`} style={{ gridColumn: '1 / -1', height: '0' }} />;
                                    }
                                
                                    if (field.fullWidth) {
                                        return (
                                            <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                                {fields(field, index, data, setData, false, null, '100%')}
                                            </div>
                                        );
                                    }
                                    return fields(field, index, data, setData, null, null)
                                })}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><AttachMoney style={{ marginRight: '10px', scale: '1.3' }} /> {t("Equipment") + ' ' + t("Line")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto', justifyContent: 'space-evenly' }}>
                                {EquipmentLineFields.map((field, index) => {
                                    return fields(field, index, data, setData)
                                })}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><Group style={{ marginRight: '10px', scale: '1.3' }} /> {t('Equipment') + ' ' + t('Owner')}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto', justifyContent: 'space-evenly' }}>
                                {EquipmentOwnerFields.map((field, index) => {
                                    return fields(field, index, data, setData)
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ margin: '25px' }}></div>
            </div >
            <M_MessageBoard
                warning
                open={leavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => { ctx2.closeTab(JSON.parse(id)); setLeavingPage(false) }} label={t("ButtonConfirm")} />
                    </span>
                }
            />
            {/* Check Digit Warning Message Board */}
            <M_MessageBoard
                warning
                open={showCheckDigitWarning}
                title={t("Invalid Check Digit")}
                body={`${t("Equipment ID")} ${data.prefix?.toUpperCase()}${data.number} ${data.cd} ${t("failed ISO 6346 check digit validation. Do you want to proceed anyway?")}`}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'}
                            onClick={() => {
                                setShowCheckDigitWarning(false)
                            }}
                            label={t("ButtonCancel")}
                        />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'}
                            onClick={onForceCreation}
                            label={t("ButtonConfirm")}
                        />
                    </span>
                }
            />
            {/* Equipment Type Creation Drawer */}
            <M_ElementDrawer
                open={showEquipmentType}
                setOpen={setShowEquipmentType}
                onClose={() => {
                    setShowEquipmentType(false)
                    setNewEquipmentTypeData({})
                }}
                element={
                    <div style={{ margin: '0px 5px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px 0px' }}>
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <h2 style={{ color: ctx.secondaryColor, display: 'flex', alignItems: 'center', marginTop: '0px' }}><Anchor style={{ marginRight: '5px', fontSize: '30px' }} />
                                    {t('New') + ' ' + t('EquipmentType') + ' ' + t('Details')}
                                </h2>
                            </span>
                            <div style={{ border: `1px solid ${ctx.primaryColor}`, width: '90%' }}></div>
                        </div>
                        
                        {/*Equipment Type Fields */}
                        <div style={{display: 'grid', gridTemplateColumns: 'auto auto auto', margin: '20px', gap: '20px', alignItems: 'start' }}>          
                            {addEquipmentTypeFields.map((field, index) => {
                                if (field.fullWidth) {
                                    return (
                                        <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                            {fields(field, index, newEquipmentTypeData, setNewEquipmentTypeData, false, null, '100%')}
                                        </div>
                                    );
                                }
                                return fields(field, index, newEquipmentTypeData, setNewEquipmentTypeData, null, null)
                            })}
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '50px 0px' }}>
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <h2 style={{ color: ctx.secondaryColor, display: 'flex', alignItems: 'center', marginTop: '0px' }}><LabelOutlined style={{ marginRight: '5px', fontSize: '30px' }} />
                                    {t('Equipment') + ' ' + t('Class') + ' ' + t('Details')}
                                </h2>
                            </span>
                            <div style={{ border: `1px solid ${ctx.primaryColor}`, width: '90%' }}></div>
                        </div>

                        {/* Equipment Class Fields */}
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', margin: '20px', gap: '20px', alignItems: 'start' }}>          
                            {addEquipmentClassFields.map((field, index) => (
                                <div key={index}>
                                    {fields(field, index, newEquipmentTypeData, setNewEquipmentTypeData)}
                                </div>
                            ))}
                        </div>
                        <div style={{ margin: '30px 0' }}></div>
                        
                        {/* Buttons Save & Cancel */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', marginRight: '20px', marginLeft: '20px' }}>                            
                            <M_Button
                                hoverEffect
                                width={20}
                                label={t("Save")}
                                onClick={() => saveNewEquipmentType()}
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                            />
                            <M_Button
                                hoverEffect
                                width={15}
                                label={t("Cancel")}
                                onClick={() => {
                                    setShowEquipmentType(false)
                                    setNewEquipmentTypeData({})
                                }}
                                backgroundColor={'var(--color-red)'}
                                labelColor={'var(--color-white)'}
                            />

                        </div>
                    </div>
                }
            />
        </div >
    )
}
